import React from 'react'

import './PageNotFound.css'

export default function PageNotFound() {
    return (
        <div id="notFoundComponent">
            <div id="notFoundContent">
                <i id="notFoundIntro">Aww Snap!</i>
                <h1 id="notFoundName">Page Not Found</h1>
            </div>
        </div>
    )
}
